import moment from 'moment';

function Entity(data) {
    this.tableData = this.createTableData(data);
    this.pagination = this.createPaginationData(data);
}

Entity.prototype = Object.assign(Entity.prototype, {
    createTableData(tableData) {
        return (
            tableData &&
            tableData.data &&
            tableData.data.map(row => this.createRow(row))
        );
    },
    createPaginationData(data) {
        if (data && data.paging) {
            const {
                hasNextPage,
                hasPreviousPage,
                pageNumber,
                pageSize,
                sortingCriteria,
                totalNumberOfPages,
                totalNumberOfRecords,
            } = data.paging;
            return {
                hasNextPage,
                hasPreviousPage,
                pageNumber,
                pageSize,
                sortingCriteria,
                totalNumberOfPages,
                totalNumberOfRecords,
            };
        }
        return {};
    },
    createRow(row) {
        const {
            entityType,
            entityCode,
            email,
            mobile,
            relationshipManagerId,
            axisAcquiredMerchantId,
            mcc,
            status,
            createdDate,
            name,
            mode,
            isEditMode,
            verificationStatus,
            entityStatus,
            parentEntityName,
        } = row;
        return {
            entityType: entityType || '-',
            entityCode: entityCode || '-',
            email: email || '-',
            mobile: mobile || '-',
            relationshipManagerId: relationshipManagerId || '-',
            axisAcquiredMerchantId: axisAcquiredMerchantId || '-',
            mcc: mcc || '-',
            status: this.formatStatus(status) || '',
            createdDate: this.formatData(createdDate) || '-',
            name: name || '-',
            mode: mode || '-',
            isEditMode,
            entityStatus,
            parentEntityName,
        };
    },
    formatData(date) {
        return moment(date).format('DD/MM/YYYY');
    },
    formatStatus(entityStatus) {
        if (entityStatus === 1) {
            return 'Active';
        } else if (entityStatus === 5) {
            return 'Inactive with settlement';
        } else if (entityStatus === 0) {
            return 'In process';
        }
        return 'Inactive';
    },
});

export default Entity;
